import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { interactiveTransition, theme } from 'modules/tetrisTheme';
const containerSize = {
    small: 'xl',
    large: '2xl',
};
export const Container = styled.div `
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
`;
export const InputContainer = styled.div `
  flex-shrink: 0;
  display: inline-block;
  position: relative;
  width: ${(props) => theme.spacing[containerSize[props.$size]]};
  height: ${(props) => theme.spacing[containerSize[props.$size]]};
`;
export const Overlay = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  pointer-events: none;
  inset: 0;
  border: ${pxToRem(1)} solid ${theme.semantic.border.strong};

  & svg {
    color: ${theme.semantic.foreground.inverse};
  }

  background-color: ${theme.semantic.surface.primary};
  border-color: ${(props) => props.$invalid && theme.swatches.red[500]};
  box-shadow: 0 0 0 ${theme.spacing.xs} transparent;
  ${interactiveTransition};
`;
const checkedStyles = css `
  &:checked + div {
    & svg {
      color: ${theme.semantic.foreground.inverse};
    }

    background-color: ${(props) => (props.$invalid ? theme.swatches.red[400] : theme.semantic.surface.inverse)};
    border-color: ${(props) => (props.$invalid ? theme.swatches.red[500] : theme.swatches.warm[800])};
    box-shadow: 0 0 0 ${theme.spacing.xs} transparent;
  }
`;
const indeterminateStyles = css `
  &:indeterminate:not([type='radio'], :disabled) + div {
    & svg {
      color: ${theme.semantic.foreground.inverse};
    }

    background-color: ${(props) => (props.$invalid ? theme.swatches.red[400] : theme.semantic.surface.inverse)};
    border-color: ${(props) => (props.$invalid ? theme.swatches.red[500] : theme.swatches.warm[800])};
    box-shadow: 0 0 0 ${theme.spacing.xs} transparent;
  }
`;
const hoverStyles = css `
  &:not(:disabled):hover + div {
    filter: brightness(0.9);
  }
`;
const focusStyles = css `
  &:not(:disabled):focus-visible + div {
    & svg {
      color: ${theme.semantic.foreground.inverse};
    }

    background-color: ${theme.semantic.surface.primary};
    border-color: ${(props) => (props.$invalid ? theme.swatches.red[500] : theme.swatches.warm[600])};
    box-shadow: 0 0 0 ${theme.spacing.xs} ${theme.semantic.focus.ring};
  }

  &:not(:disabled):focus-visible:checked + div {
    background-color: ${(props) => (props.$invalid ? theme.swatches.red[400] : theme.semantic.surface.inverse)};
  }
`;
const activeStyles = css `
  &:not(:disabled):active + div {
    & svg {
      color: ${theme.semantic.foreground.secondary};
    }

    background-color: ${theme.semantic.surface.sunken};
    border-color: ${theme.swatches.warm[1000]};
    box-shadow: 0 0 0 ${theme.spacing.xs} transparent;
  }
`;
const disabledStyles = css `
  &:disabled + div {
    & svg {
      color: ${theme.swatches.warm[100]};
    }

    background-color: ${theme.semantic.action.primary.disabled};
    border-color: ${theme.semantic.border.strong};
    box-shadow: 0 0 0 ${theme.spacing.xs} transparent;
  }

  &:disabled:checked + div {
    & svg {
      color: ${theme.swatches.warm[500]};
    }
  }
`;
export const Input = styled.input `
  position: absolute;
  margin: 0;
  width: 100%;
  height: 100%;
  border: 0;
  appearance: none;
  opacity: 0;

  :focus-visible {
    outline: none;
  }

  ${checkedStyles};
  ${indeterminateStyles};
  ${hoverStyles};
  ${activeStyles};
  ${focusStyles};
  ${disabledStyles};
`;
export const Label = styled.label `
  display: inline-block;
  font: ${theme.fontRole.label};
  color: ${theme.semantic.foreground.tertiary};
  overflow-wrap: break-word;
  overflow: hidden;
`;
